import React from 'react'

import Icon from 'app/views/components/Icon'

import settings from 'settings'

class DraggableSections extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      display: this.props.initialShow ? 'block' : 'none',
      filters: {

      },
    }
    this.handleDisplay = this.handleDisplay.bind(this)
    this.onClickFilterButton = this.onClickFilterButton.bind(this)
  }

  componentDidMount() {
    if (this.props.contentType === 'coding_challenges') {
      if (!this.props.defaultFilters || Object.keys(this.props.defaultFilters).length === 0) {
        this.setState({
          filters: this.props.content.code_reviews.reduce((prev, language) => {
            prev[language.language_name] = false
            return prev
          }, {}),
        })
      } else {
        this.setState({
          filters: this.props.content.code_reviews.reduce((prev, language) => {
            prev[language.language_name] = Boolean(this.props.defaultFilters[language.language_name])
            return prev
          }, {}),
        })
      }
    }
  }


  componentDidUpdate() {
    if (this.props.display !== this.state.display) {
      this.handleDisplay()
    }
  }


  onClickFilterButton(language) {
    const { filters } = this.state
    this.setState({
      filters: {
        ...filters,
        [language]: !filters[language],
      },
    })
  }

  handleDisplay() {
    this.setState({
      display: this.props.display,
    })
  }

  renderStyle(isActive) {
    if (isActive) {
      return {
        fontWeight: 'bold',
        backgroundColor: '#d8eafb',
      }
    }
    return {}
  }

  render() {
    return (
      <>
        {this.props.contentType === 'coding_challenges' && this.state.display === 'block' && (
          <div
            className="uk-flex  uk-flex-left uk-flex-middle uk-flex-wrap uk-width-1-1"
          >
            {this.props.content.code_reviews.map((language) => (
              <button
                key={language.language_name}
                name={language.language_name}
                onClick={this.onClickFilterButton.bind(this, language.language_name)}
                className="uk-button uk-button-default uk-button-small uk-margin-small-right uk-flex-inline uk-flex-middle uk-margin-small-top"
                style={this.renderStyle(this.state.filters[language.language_name])}
                type="button"
              >
                <i
                  className={`devicon-${settings.engineIcons[language.language_name]}-plain colored uk-margin-small-right`}
                  style={{ fontSize: 12 }}
                  title={settings.engines[language.language_name]}
                />
                {settings.engines[language.language_name]}
              </button>
            ))}
          </div>
        )}
        <div style={{ display: this.state.display }}>
          <label className="uk-form-label">
            Choose Lessons
            <Icon
              href="#"
              name="information"
              ratio={0.85}
              data-uk-toggle="target: #modal-choose-lessons"
              style={{ marginLeft: 8, cursor: 'pointer' }}
            />
          </label>
          <div
            id="lessons-list-to-choose"
            data-test-id="choose-lesson-left"
            className="uk-placeholder"
            style={{
              width: 305,
              paddingLeft: 0,
              paddingTop: 0,
              paddingRight: 0,
              paddingBottom: 0,
            }}
          >
            {Object.keys(this.props.content).length > 0 && Object.keys(this.props.content).map((contentKey) => {
              if (this.props.contentType === 'lessons') {
                if (contentKey === 'courses') {
                  return (
                    <div key={contentKey} className="uk-padding-small">
                      <b>{contentKey.charAt(0).toUpperCase() + contentKey.slice(1)}</b>
                      {this.props.content[contentKey].map((course) => {
                        return (
                          <React.Fragment key={course.uuid}>
                            <ul className="uk-nav uk-nav-default draggable" data-uk-sortable="group: sortable-group">
                              <li className="uk-disabled uk-active" style={{ marginLeft: 10 }}>
                                {course.title}
                              </li>
                              {course.items.map((item) => {
                                if (item.item_type === 'lesson') {
                                  return (
                                    <React.Fragment key={item.uuid}>
                                      <li
                                        className="uk-drag"
                                        key={item.uuid}
                                        id={item.uuid}
                                        data-type={item.item_type}
                                        data-content-uuids={item.item_type === 'lesson' ? JSON.stringify(item.content.map((c) => c.uuid)) : ''}
                                      >
                                        <a
                                          href="#"
                                          id={item.uuid}
                                          data-course-uuid={course.uuid}
                                          style={{ paddingLeft: 20 }}
                                        >
                                          <i>
                                            {`${item.title} Lesson`}
                                          </i>
                                        </a>
                                      </li>
                                      {item.content.map((itm) => {
                                        if (this.props.hideContent && this.props.hideContent[itm.uuid]) {
                                          return null
                                        }
                                        return (
                                          <li
                                            className="uk-drag uk-margin-small-left"
                                            key={itm.uuid}
                                            id={itm.uuid}
                                            data-type="content"
                                            data-content-uuids=""
                                          >
                                            <a
                                              href="#"
                                              id={itm.uuid}
                                              data-course-uuid={course.uuid}
                                              style={{ paddingLeft: 20 }}
                                            >
                                              {itm.title}
                                            </a>
                                          </li>
                                        )
                                      })}
                                    </React.Fragment>
                                  )
                                }
                                if (this.props.hideContent && this.props.hideContent[item.uuid]) {
                                  return null
                                }
                                return (
                                  <li
                                    className="uk-drag"
                                    key={item.uuid}
                                    id={item.uuid}
                                    data-type={item.item_type}
                                    data-content-uuids={item.item_type === 'lesson' ? JSON.stringify(item.content.map((c) => c.uuid)) : ''}
                                  >
                                    <a
                                      href="#"
                                      id={item.uuid}
                                      data-course-uuid={course.uuid}
                                      style={{ paddingLeft: 20 }}
                                    >
                                      {item.title}
                                    </a>
                                  </li>
                                )
                              })}
                            </ul>
                          </React.Fragment>
                        )
                      })}
                    </div>
                  )
                }
                if (contentKey === 'challenges') {
                  return (
                    <div key={contentKey} className="uk-padding-small">
                      <b>{contentKey.charAt(0).toUpperCase() + contentKey.slice(1)}</b>
                      <ul className="uk-nav uk-nav-default uk-width-medium draggable" data-uk-sortable="group: sortable-group">
                        {this.props.content[contentKey].map((item) => {
                          if (this.props.hideContent && this.props.hideContent[item.uuid]) {
                            return null
                          }
                          return (
                            <li className="uk-drag" key={item.uuid} id={item.uuid} data-type="hacking_challenge">
                              <a href="#" id={item.uuid} style={{ paddingLeft: 20 }}>{item.title}</a>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  )
                }
              } else if (this.props.contentType === 'coding_challenges' && contentKey === 'code_reviews') {
                return (
                  <div key={contentKey} className="uk-padding-small">
                    <b>Coding Challenges</b>
                    <ul className="uk-nav uk-nav-default uk-width-medium draggable" data-uk-sortable="group: sortable-group">
                      {Object.values(this.state.filters).filter((f) => f === true).length === 0 && (
                        <li
                          className="uk-disabled uk-text-center uk-margin-top uk-margin-bottom uk-text-emphasis uk-padding"
                        >
                          <h5>
                            Please select at least one language above
                          </h5>
                        </li>
                      )}
                      {this.props.content[contentKey].map((language) => {
                        return (
                          <React.Fragment key={language.language_name}>
                            <li
                              className="uk-disabled"
                              style={{
                                marginLeft: 10,
                                display: this.state.filters[language.language_name] ? 'block' : 'none',
                              }}
                            >
                              {settings.engines[language.language_name]}
                            </li>
                            {language.frameworks.map((framework) => (
                              <React.Fragment key={framework.name}>
                                <li
                                  style={{
                                    display: this.state.filters[language.language_name] ? 'block' : 'none',
                                  }}
                                  className="uk-disabled"
                                  key={framework.name}
                                  id={framework.name}
                                  data-type="framework"
                                >
                                  <a
                                    href="#"
                                    id={framework.name}
                                    data-framework-name={framework.name}
                                    style={{ paddingLeft: 20 }}
                                  >
                                    {`${settings.frameworks[framework.name]}`}
                                  </a>
                                </li>
                                {framework.apps.map((app) => (
                                  <React.Fragment key={`${language.language_name}-${framework.name}-${app.name}`}>
                                    <li
                                      style={{
                                        display: this.state.filters[language.language_name] ? 'block' : 'none',
                                      }}
                                      className="uk-drag uk-margin-small-left"
                                      key={app.name}
                                      id={`${language.language_name}-${framework.name}-${app.name}`}
                                      data-type="app"
                                      data-content-uuids={JSON.stringify(app.content.map((c) => c.uuid))}
                                    >
                                      <a
                                        href="#"
                                        id={app.name}
                                        data-framework-name={app.name}
                                        style={{ paddingLeft: 20 }}
                                      >
                                        <i>
                                          {`${settings.apps[app.name]}`}
                                        </i>
                                      </a>
                                    </li>
                                    {app.content.map((content) => {
                                      if (this.props.hideContent && this.props.hideContent[content.uuid]) {
                                        return null
                                      }
                                      return (
                                        <li
                                          style={{
                                            display: this.state.filters[language.language_name] ? 'block' : 'none',
                                          }}
                                          className="uk-drag uk-margin-medium-left"
                                          data-framework-name={framework.framework_name}
                                          data-selected-name={`${settings.apps[app.name]}: ${content.title} (${settings.engines[language.language_name]} - ${settings.frameworks[framework.name]})`}
                                          key={content.uuid}
                                          id={content.uuid}
                                          data-type="hacking_challenge"
                                          data-content-uuids=""
                                        >
                                          <a
                                            href="#"
                                            id={content.uuid}
                                            style={{ paddingLeft: 20 }}
                                          >
                                            {content.title}
                                          </a>
                                        </li>
                                      )
                                    })}

                                  </React.Fragment>
                                ))}
                              </React.Fragment>
                            ))}
                          </React.Fragment>
                        )
                      })}
                    </ul>
                  </div>
                )
              }
            })}
          </div>
        </div>
      </>

    )
  }
}

export default DraggableSections
